import { render, staticRenderFns } from "./roles.vue?vue&type=template&id=9e99fd6e&scoped=true"
import script from "./roles.vue?vue&type=script&lang=js"
export * from "./roles.vue?vue&type=script&lang=js"
import style0 from "./roles.vue?vue&type=style&index=0&id=9e99fd6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e99fd6e",
  null
  
)

export default component.exports